import { Outlet, RouterProvider, createBrowserRouter } from 'react-router-dom';
import { Button, Result } from 'antd';
import { AccessDenied, MenuIndex, MenuRoute } from './views/Navigation/MenuRoute';
import SystemRoutes from './views/Navigation/SystemRoutes';
import { observer } from 'mobx-react';
import authStore from './stores/authStore';
import { useEffect, useState } from 'react';
import appConfigStore from './stores/appConfigStore';
import AdminDashboardView from './views/Admin/AdminDashboard';
import GuestRoutes from './views/Navigation/GuestRoutes';
import { useWindowSize } from '@uidotdev/usehooks';
import MobileView from './views/Mobile/MobileView';
import PaymentCheckoutModal from './components/PaymentCheckoutModal';

const MyApp = observer(() => {
  if (authStore.isGuest) {
    return <GuestRoutes />;
  }


  return <AppManageStore />;
});


export default MyApp;

const AppManageStore = observer(() => {
  const size = useWindowSize();
  const [router] = useState(() => createBrowserRouter(getSystemRoutes()));
  const [configError, setConfigError] = useState(false);

  const loadConfig = async () => {
    setConfigError(false);
    try {
      await appConfigStore.getConfig();
    } catch {
      setConfigError(true);
    }
  };

  useEffect(() => {
    loadConfig();
  }, []);

  if (configError && !appConfigStore.config) {
    return <Result status="error" title="Не удалось загрузить доступные разделы" extra={<Button onClick={loadConfig}>Повторить</Button>} />;
  }

  if (!appConfigStore.config) {
    return <div />;
  }

  if (appConfigStore.isSuperAdmin) {
    return <AdminDashboardView />;
  }

  if (size.width && size.width < 500 && !appConfigStore.isOwner) {
    return <MobileView />;
  }

  return <><RouterProvider router={router} /><PaymentCheckoutModal /></>;
});

export const getSystemRoutes = () => {
  return SystemRoutes.map((route) => route.path !== "/" ? route : {
    ...route,
    children: [
      { index: true, element: <MenuIndex /> },
      ...(route.children ?? []).filter((child) => child.path !== "*").map((child) => ({
        ...child,
        element: <MenuRoute>{child.element ?? <Outlet />}</MenuRoute>,
      })),
      { path: "*", element: <AccessDenied /> },
    ],
  });
};
